// 常駐活動中獎紀錄、轉盤獎勵 彈窗
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { popState, setCampaignRecordModal } from '@/slices/popSlice';
import dayjs from 'dayjs';
import CampaignEmptyRecord from './CampaignEmptyRecord';

// tab 按鈕
const tabButtons = [
    { title: '開獎紀錄', type: 'draw' },
    { title: '轉盤獎勵', type: 'spin' },
];

const CampaignRecords = () => {
    const dispatch = useDispatch();
    const { campaignUserInfo, showCampaignRecord } = useSelector(popState);
    const [recordType, setRecordType] = useState('draw'); // draw 開獎紀錄 spin 轉盤獎勵

    // 關閉彈窗
    const onClose = () => dispatch(setCampaignRecordModal(false));

    return (
        <div id="campaign-records-modal" className={`modal ${showCampaignRecord ? 'act' : ''}`}>
            <div
                className="relative z-[1] border-1 border-[#fff] border-opacity-[.3] rounded-[22px] px-[40px] py-[30px] w-[400px] max-w-[96%] max-h-[96vh]
            bg-[#000] bg-opacity-[.44] backdrop-blur-[9px] usm:px-[20px]"
            >
                <div className="border-1 h-[49px] border-[#fff] border-opacity-[.3] rounded-[40px] max-w-[269px] mx-auto between-center relative mb-[35px]">
                    {/* 按鈕背景 */}
                    <span
                        className={`absolute z-[-1] backdrop-blur-[5px] trans bg-[#00b2cf] bg-opacity-[.74] w-[50%] top-0 h-full border-1 border-[#fff] border-opacity-[.3] rounded-[40px]
                        ${recordType === 'draw' ? 'left-0' : 'left-[calc(50%+1px)]'}`}
                    />
                    {/* 切換紀錄按鈕 */}
                    {tabButtons.map((tab) => (
                        <button
                            onClick={() => setRecordType(tab.type)}
                            key={'tab' + tab.type}
                            className={`trans relative z-[1] px-[35px] py-[13px] text-btn1 text-[#fff]
                            ${recordType !== tab.type ? 'opacity-[.4]' : ''}`}
                        >
                            {tab.title}
                        </button>
                    ))}
                </div>

                <div className="max-h-[calc(96vh-130px-49px-29px)] noScrollY [&>*]:between-center">
                    {/* 開獎紀錄 */}
                    {recordType === 'draw' ? (
                        campaignUserInfo?.drawLogs?.length > 0 ? (
                            <>
                                <div className="text-[#fff] text-btn1b mb-[8px]">
                                    <span>開獎紀錄</span>
                                    <span>時間</span>
                                </div>
                                {campaignUserInfo?.drawLogs?.map((log, i) => (
                                    <div
                                        key={'drawLog' + i}
                                        className={`py-[12px] border-[#868686] border-opacity-[.5] [&_span]:block gap-x-[25px] [&>p]:space-y-[6px] text-bd4n text-[#fff]
                                    ${
                                        i < campaignUserInfo?.spinAwards?.length - 1
                                            ? 'border-b-1'
                                            : ''
                                    }`}
                                    >
                                        <p>
                                            <span>獲得獎勵：{log?.awardName || '無'}</span>
                                            <span className="text-[#9b9b9b]">
                                                消耗抽獎券：{log?.usedTickets}
                                            </span>
                                        </p>
                                        <p className="text-right flex-shrink-0 ">
                                            <span>{log?.drawDate}</span>
                                            <span className="text-[#9b9b9b]">{log?.drawTime}</span>
                                        </p>
                                    </div>
                                ))}
                            </>
                        ) : (
                            // 無紀錄
                            <CampaignEmptyRecord />
                        )
                    ) : // 轉盤獎勵
                    campaignUserInfo?.spinAwards?.length > 0 ? (
                        <>
                            <div className="text-[#fff] text-btn1b mb-[8px]">
                                <span>轉盤獎勵</span>
                                <span>時間</span>
                            </div>
                            {campaignUserInfo?.spinAwards?.map((log, i) => (
                                <div
                                    key={'spinLog' + i}
                                    className={`py-[12px]  border-[#868686] border-opacity-[.5] text-bd4n between-center gap-y-[25px] text-[#fff]
                                ${
                                    i < campaignUserInfo?.spinAwards?.length - 1 ? 'border-b-1' : ''
                                }`}
                                >
                                    <p>獲得獎勵：{log?.awardName}</p>
                                    <div className="text-right">
                                        <p>{dayjs(log?.createdTime).format('YYYY.MM.DD')}</p>
                                        <p className="text-[#9b9b9b] ">
                                            {dayjs(log?.createdTime).format('HH:mm')}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        // 無紀錄
                        <CampaignEmptyRecord />
                    )}
                </div>

                <button
                    onClick={onClose}
                    className="px-[35px] h-[29px] mt-[35px] block mx-auto py-[6px] rounded-[4px] text-bd4n text-[#fff] bg-[#fff] bg-opacity-[.11]"
                >
                    關閉
                </button>
            </div>

            {/* 關閉用背景 */}
            <div className="close-bg" onClick={onClose} />
        </div>
    );
};

export default CampaignRecords;
